module.exports = __webpack_public_path__ + "img/phone2.276fbd5f.png";